const config = {
	apiUrl: process.env.REACT_APP_API_URL,
	polarisApiUrl: process.env.REACT_APP_POLARIS_API_URL,
	environment: process.env?.REACT_APP_ENV || "production",
	pageTitlePostFix: "MapX: AI Powered Executive Talent Mapping",
	mixPanelToken: process.env?.REACT_APP_MIXPANEL_TOKEN,
};

export default config;
